module.exports = __webpack_public_path__ + "static/media/natal de bem.40bae16a.jpeg";